import { useMemo } from 'react';
import { FeatureDefinition } from '../types/feature.types';
import { settingsDefinition } from './settings';
import { toolsDefinition } from './tools';
import { aiFeaturesDefinition } from './ai-features';

const allFeatures: FeatureDefinition[] = [
  aiFeaturesDefinition,
  toolsDefinition,
  settingsDefinition,
];

export function useFeatureRegistry(): FeatureDefinition[] {
  return useMemo(
    () =>
      allFeatures
        .filter((f) => f.enabled)
        .sort((a, b) => a.order - b.order),
    [],
  );
}
